import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'ciwc-id-od-validation-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatDialogContent, MatDialogActions],
  templateUrl: './id-od-validation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdOdValidationDialogComponent {}
